export default __webpack_public_path__ + "static/img-slider-05-86b43bed0f9a5f951fc193c4eda09c6b.png";